import React from 'react';
import { ThemedLink } from '@helpcenter/themed-link';
import errorImg from 'assets/images/search-modal-error.svg';
import { useIntl } from 'react-intl';
import Heading from '@atlaskit/heading/heading';
import { Stack } from '@atlaskit/primitives/stack';
import { getHelpCenterUrl } from '@atlassian/help-center-common-util/url';
import { Img } from '../common';
import messages from './messages';

const SearchResultError = () => {
	const { formatMessage } = useIntl();

	return (
		<Stack alignInline="center">
			<Img src={errorImg} />
			<Heading size="xsmall">{formatMessage(messages.searchErrorTitle)}</Heading>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text,@atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve */}
			<p style={{ textAlign: 'center' }}>
				{formatMessage(messages.searchErrorText, {
					helpCenterLink: (
						// eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
						<ThemedLink to={getHelpCenterUrl()} actionSubjectId="helpCenterLink">
							{formatMessage(messages.helpCenter)}
						</ThemedLink>
					),
				})}
			</p>
		</Stack>
	);
};

export default SearchResultError;
